module.exports = __webpack_public_path__ + "img/cpe_icons_duration.ceb8c496.svg";